const ignoredTags = [
  'BUTTON',
  'A',
  'INPUT',
  'TEXTAREA',
  'LABEL',
];

const ClickableTable = {
  /**
   * @param {Node} node
   * @return {void}
   */
  create(node) {
    this.node = node;

    $(this.node).on('click', 'tr', this.handleRowClick.bind(this));
  },

  /**
   * @param {object} event
   * @returns {boolean}
   */
  handleRowClick(event) {
    if (!this.isNotIgnored(event.target)) {
      return true;
    }

    const $row = $(event.currentTarget);
    const url = $row.data('url');

    if (typeof url === 'undefined') {
      return true;
    }

    if (this.isMetaKeyPushed(event)) {
      window.open(url, '_blank');
    } else {
      window.location = url;
    }

    return false;
  },

  /**
   * Check in the event object if a meta key has been pressed
   *
   * @param {object} event
   * @returns {boolean}
   */
  isMetaKeyPushed(event) {
    return (
      event.metaKey
      || event.ctrlKey
    );
  },

  /**
   * Check if the clicked element should be ignored (e.g. buttons, links, input, etc.)
   *
   * @param {HTMLElement} target
   * @returns {boolean}
   */
  isNotIgnored(target) {
    const { tagName } = target;

    return (
      ignoredTags.indexOf(tagName) < 0
      && !$(target).parents(ignoredTags.join(', ')).length
    );
  },
};

export default ClickableTable;
